import React, { useState, useEffect } from 'react'
import TextField from '@material-ui/core/TextField'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import Typography from '@material-ui/core/Typography'
import RemoveIcon from '@material-ui/icons/Remove'
import InputAdornment from '@material-ui/core/InputAdornment'
import clsx from 'clsx'

import { useProjectsFiltersStyles } from './projects-filters.styles'
import { useProjectsFilters } from '../use-projects-filters'
import { TranslationDictionary, useLocale } from '@plandi/common'

type Props = {
  translate?: TranslationDictionary['data']
}

export const ProjectsFiltersCost: React.FC<Props> = ({ translate }) => {
  const classes = useProjectsFiltersStyles()

  const { toCost, fromCost, setProjectsFiltersDebounce } = useProjectsFilters()
  const locale = useLocale()

  const [projectCostValue, setProjectCostValue] = useState({
    fromCost,
    toCost
  })

  useEffect(() => {
    if (!toCost && !fromCost) {
      setProjectCostValue({ toCost, fromCost })
    }
  }, [toCost, fromCost])

  const handleChangeCostValue = (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>
  ) => {
    const maxValue = 99999999

    const value = event.target.value ? Number(event.target.value) : undefined

    const name = event.target.name as 'fromCost' | 'toCost'

    if (!value || value <= maxValue) {
      setProjectCostValue((old) => ({
        ...old,
        [name]: value
      }))

      setProjectsFiltersDebounce({
        [name]: value
      })
    }
  }

  return (
    <Accordion
      className={clsx(classes.accordion, classes.costAccordion)}
      classes={{ expanded: classes.accordionExpanded }}
      defaultExpanded
    >
      <AccordionSummary
        className={classes.accordionSummary}
        classes={{
          expanded: classes.accordionSummaryExpanded,
          content: classes.accordionSummaryContent
        }}
        expandIcon={<ExpandMoreIcon />}
      >
        <Typography style={{ fontWeight: 500 }} variant="subtitle1">
          {translate?.shop['projects-page']['cost-project']}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className={classes.costAccordionDetails}>
        <TextField
          variant="outlined"
          value={projectCostValue.fromCost ?? ''}
          size="small"
          type="number"
          name="fromCost"
          onChange={(e) => {
            if (e.target.value === '') {
              handleChangeCostValue(e)
              return
            }
            const value = +e.target.value
            if (value >= 0) {
              handleChangeCostValue(e)
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {locale === 'ru' ? '₽' : '$'}
              </InputAdornment>
            )
          }}
        />
        <Typography className={classes.delimeter}>
          <RemoveIcon htmlColor="#9E9E9E" />
        </Typography>
        <TextField
          variant="outlined"
          value={projectCostValue.toCost ?? ''}
          size="small"
          type="number"
          name="toCost"
          onChange={(e) => {
            if (e.target.value === '') {
              handleChangeCostValue(e)
              return
            }
            const value = +e.target.value
            if (value >= 0) {
              handleChangeCostValue(e)
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {locale === 'ru' ? '₽' : '$'}
              </InputAdornment>
            )
          }}
        />
      </AccordionDetails>
    </Accordion>
  )
}
